<div class="push-api-settings">
    <div [id]="reactWrapperId">
      <!-- React component will be rendered inside this div -->
    </div>
</div>
